import { widget } from '../charting_library/';
import Datafeed from "./utils/datafeed/Datafeed";
import save_load_adapter from "./utils/save_load_adapter";
import { useEffect, useRef, useState, useMemo } from "react";
import { Connect_feed_server, Initialize_proto } from "./utils/streaming/SingalRStreaming";

const Chart = () => {
  const chartContainerRef = useRef();
  const [missingParams, setMissingParams] = useState(null); 

  const params = useMemo(() => new URLSearchParams(window.location.search), []);

  useEffect(() => {
    const requiredParams = ["symbol", "user_id", "identifier"];
    const paramsMissing = requiredParams.some((key) => !params.get(key));

    const allowedIdentifiers = ["sharemarkett"];
    const identifier = params.get("identifier");
    const invalidIdentifier = identifier && !allowedIdentifiers.includes(identifier);

    setMissingParams(paramsMissing || invalidIdentifier);
  }, [params]);

  useEffect(() => {
    if (missingParams === false) {
      Connect_feed_server();
      Initialize_proto();

      const widgetOptions = {
        symbol: params.get("symbol"),
        datafeed: Datafeed,
        container: chartContainerRef.current,
        save_load_adapter: save_load_adapter,
        client_id: 'tradingview.com',
        user_id: 'public_user_id',
        fullscreen: true,
        autosize: true,
        overrides: {
          "mainSeriesProperties.candleStyle.barColorsOnPrevClose": true,
        },
        theme: params.get("mode") === "white" ? "white" : "dark",
        interval: '1',
        library_path: '/charting_library/',
        locale: 'en',
        disabled_features: ['use_localstorage_for_settings'],
        enabled_features: [
          'study_templates',
          'chart_property_page_style',
          'chart_property_page_candle',
        ],
      };

      const tvWidget = new widget(widgetOptions);
       tvWidget.onChartReady(() => {
        const chart = tvWidget.activeChart();
        chart.onSymbolChanged().subscribe(null, (symbolInfo) => {
          console.log(`symbolId:${symbolInfo.id}`);
        });
      });

      return () => tvWidget.remove();
    }
  }, [missingParams, params]);

  if (missingParams === null) {
    return <p>Loading...</p>; 
  }

  if (missingParams) {
    return <div><p>Missing or invalid parameter</p></div>;
  }

  return <div ref={chartContainerRef} className="TVChartContainer" />;
};

export default Chart;
